<template>
    <!-- 报表管理－员工打卡 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'attendanceRecordManage')">
            <a-card :border="false" title="员工打卡记录">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['startTime',{initialValue: [$moment(),$moment()]}]"
                        />
                    </a-form-item>
                    <a-form-item label="员工姓名">
                        <a-input placeholder="请输入" v-decorator="['employeeName']"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button" v-if="getBtnByAuth('attendanceRecordImport') || getBtnByAuth('attendanceRecordImport2')">
                        <a-upload
                            name="file"
                            :showUploadList="false"
                            @change="handleChange"
                            accept=".xlsx"
                            :customRequest="customRequest"
                            :disabled="importLoading"
                        >
                            <a-button><a-icon type="upload" />导入excel</a-button>
                        </a-upload>
                    </a-form-item>
                    <a-form-item v-if="getBtnByAuth('attendanceRecordExport')">
                        <a-button type="primary" @click="exportExcel" :loading="loading">导出excel</a-button>
                    </a-form-item>
                    <a-form-item v-if="getBtnByAuth('attendanceRecordExport2')">
                        <a-button type="primary" @click="exportExcel2" :loading="loading2">导出 excel</a-button>
                    </a-form-item>
                </a-form>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex"
    export default {
        name: "attendanceRecordManage",
        components: {},
        props: {},
        data() {
            return {
                loading: false,
                loading2: false,
                importLoading: false
            };
        },
        methods: {
            // 导出excel2
            exportExcel2() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const startTime = values['startTime'] ? values['startTime'] : []
                    values.startDate = startTime.length > 0 ? startTime[0].format('YYYY-MM-DD') : undefined
                    values.endDate = startTime.length > 0 ? startTime[1].format('YYYY-MM-DD') : undefined
                    delete values.startTime
                    this.loading2 = true;
                    this.$api.statement.attendanceExport2({
                        query: {
                            ...values,
                        }
                    }).then(res => {
                        let a = document.createElement('a');
                        a.href = res;
                        a.click();
                        this.loading2 = false;
                    }).catch(err => {
                        this.loading2 = false;
                    });
                });
            },
            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const startTime = values['startTime'] ? values['startTime'] : []
                    values.startDate = startTime.length > 0 ? startTime[0].format('YYYY-MM-DD') : undefined
                    values.endDate = startTime.length > 0 ? startTime[1].format('YYYY-MM-DD') : undefined
                    delete values.startTime
                    this.loading = true;
                    this.$api.statement.attendanceExport({
                        query: {
                            ...values,
                        }
                    }).then(res => {
                        let a = document.createElement('a');
                        a.href = res;
                        a.click();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @handleChange 导入文件选择
             */
            handleChange(info) {
                //上传成功
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} 上传成功`);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} 上传失败`);
                }
            },
            /**
             * @beforeUpload 上传前拦截
             */
            beforeUpload(file, fileList) {
                this.importLoading = true;
                // 可用于校验文件
                return true;
            },
            /**
             * @customRequest 自定义上传
             */
            customRequest({ onSuccess, onError, onProgress, file }) {
                let formData = new FormData();
                formData.append('file', file);
                this.$api.statement.attendanceImport({
                    body: formData
                }, {
                    // 请求额外参数
                    header: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: ({ total, uploaded }) => {
                        onProgress({ percent: uploaded / total * 100 })
                    }
                }).then(res => {
                    onSuccess();
                    this.importLoading = false;
                })
                .catch(err => {
                    onError();
                    this.importLoading = false;
                })
            }
        }, 
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
        },
        computed: {
            ...mapGetters(["shopId"])
        },
    };
</script>
<style lang="scss" scoped>
</style>